import { BrowserRouter, Route, Routes } from "react-router-dom";

import "../index.css";

import AboutPage from "../pages/about";
import BulkSmsPage from "../pages/bulk-sms";
import CampaignsPage from "../pages/campaigns";
import ErrorPage from "../pages/Error";
import Webinar from "../pages/eventPage/webinar";
import FaqPage from "../pages/faq";
import Home from "../pages/homePage";
import BaseLayout from "../pages/layout";
import PricingPage from "../pages/pricing";
import PrivacyPolicyPage from "../pages/privacy-policy";
import AirtimePage from "../pages/productPage/AirtimePage";
import BulkSMSPage from "../pages/productPage/BulkSMSPage";
import UsdPage from "../pages/productPage/USDPage";
import VoicePage from "../pages/productPage/VoicePage";
import USSDPage from "../pages/ussd";

function MainRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<BaseLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/bulk-sms" element={<BulkSmsPage />} />
          <Route path="/ussd" element={<USSDPage />} />
          <Route path="/campaigns" element={<CampaignsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Route>

        <Route path="/bulksms" element={<BulkSMSPage />} />
        <Route path="/usd" element={<UsdPage />} />
        <Route path="/airtime" element={<AirtimePage />} />
        <Route path="/voice" element={<VoicePage />} />
        <Route path="/webinar" element={<Webinar />} />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default MainRouter;
